{% block acris_faq_index %}
<sw-page class="acris-faq-index sw-settings-index">
    {% block acris_faq_index_smart_bar_header %}
    <template #smart-bar-header>
        {% block acris_faq_index_smart_bar_header_title %}
        <h2>
            {% block acris_faq_index_smart_bar_header_title_text %}
                {{ $tc('acris-faq-list.index.textHeadline') }}
            {% endblock %}
        </h2>
        {% endblock %}
    </template>
    {% endblock %}

    {% block acris_faq_index_content %}
    <template #content>
        {% block acris_faq_index_content_card_view %}
        <sw-card-view>
            {% block acris_faq_index_content_card %}
            <mt-card class="acris-faq-list_index__card">
                {% block acris_faq_index_content_grid %}
                <div class="acris-settings-content-grid sw-settings__content-grid sw-settings__tabs">
                    {% block acris_faq_index_card_item %}
                        {% block acris_faq %}
                            <sw-settings-item
                                :label="$tc('acris-faq.general.mainMenuItemGeneral')"
                                :to="{ name: 'acris.faq.index' }"
                                class="acris-settings-item">
                                <template #icon>
                                    <mt-icon name="regular-question-circle"></mt-icon>
                                </template>
                            </sw-settings-item>
                        {% endblock %}
                        {% block acris_faq_group %}
                        <sw-settings-item
                            :label="$tc('acris-faq-group.general.mainMenuItemGeneral')"
                            :to="{ name: 'acris.faq.group.index' }"
                            class="acris-settings-item">
                            <template #icon>
                                <mt-icon name="regular-bars-circle"></mt-icon>
                            </template>
                        </sw-settings-item>
                        {% endblock %}
                        {% block acris_faq_more_config %}
                            {% set baseUrl = app.request.getScheme() ~ '://' ~ app.request.getHost() %}
                            <sw-settings-item
                                id="acris.faq"
                                :label="$tc('acris-faq-list.general.mainMenuItemMoreSettings')"
                                :to="{name: 'sw.extension.config', params: { namespace: 'AcrisFaq' }}"
                                class="acris-settings-item">
                                <template #icon>
                                    <mt-icon name="regular-cog"></mt-icon>
                                </template>
                            </sw-settings-item>
                        {% endblock %}
                    {% endblock %}
                </div>
                {% endblock %}
            </mt-card>
            {% endblock %}
        </sw-card-view>
        {% endblock %}
    </template>
    {% endblock %}
</sw-page>
{% endblock %}
